export type ValueOf<T> = T[keyof T];

export const ROLES = Object.freeze({
  CPO: "CPO",
  eMSP: "EMSP",
  HUB: "HUB"
})

export type RolesValues = ValueOf<typeof ROLES>;
export type RolesKeys = keyof typeof ROLES;